/* eslint-disable no-param-reassign */
import * as logger from 'loglevel';
import dayjs from 'dayjs';
import { getFares } from '../../../_integrations/everymundo/featuredPopularDestinations';
import { featuredDestinationToFlatFares } from '../../../_integrations/everymundo/utils/normalizeFareLikeData';
import { isSSR } from '@front10/utils';
import { withCommonPreloads } from './commons/commonPreloads';

const translateFilter = (filter, dateRange, originCity, budget) => {
  const filterModified = { ...filter };
  if (originCity) {
    filterModified.origins = [originCity];
  } else if (!filterModified.origins) {
    filterModified.origins = [];
  }
  // check for the initial dateRange state and if not take prepopulation.departure values
  filterModified.departure =
    dateRange.start && dateRange.end ? { ...dateRange } : { ...filterModified.departure };
  if (budget) {
    filterModified.budget = { maximum: budget };
  }
  return filterModified;
};

const translateDateRange = (dateRange) => {
  const dateRangeObj = {
    start:
      dateRange && dateRange.start && dayjs(dateRange.start).isValid()
        ? dayjs(dateRange.start).toDate()
        : undefined,
    end:
      dateRange && dateRange.end && dayjs(dateRange.end).isValid()
        ? dayjs(dateRange.end).toDate()
        : undefined
  };
  return dateRangeObj;
};

const preloadCustomPropsExecute = (cmpConfig, clientPromises, ssrPromises) => {
  return new Promise((resolve, reject) => {
    const {
      containerConfig: {
        settings: { integrationSettings, prePopulation, faresTrasformationLogic, meta, pageContext }
      },
      name,
      simulateSSR
    } = cmpConfig;

    const dateRange = prePopulation && prePopulation.dateRange;
    const budget = prePopulation && prePopulation.budget;

    const dateRangeObj = translateDateRange(dateRange);

    const filter = translateFilter(
      prePopulation,
      dateRangeObj,
      prePopulation.originCity,
      prePopulation && budget && budget.maximum ? budget.maximum : null
    );

    let promises = [];
    if (!isSSR(simulateSSR)) {
      promises = clientPromises;
    } else {
      ssrPromises.push(
        getFares(filter, integrationSettings, faresTrasformationLogic, meta, pageContext)
      );
      promises = ssrPromises;
    }

    Promise.all(promises)
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .then(([other, data]) => {
        cmpConfig.containerConfig.settings.getFares = getFares;
        cmpConfig.containerConfig.settings.initialFeaturedDestination = data.popularDestinations;
        cmpConfig.containerConfig.settings.initialTopFeaturedDestination =
          data.topPopularDestination;
        // Fares Schema Implementation -> https://everymundo.atlassian.net/browse/FC-1700
        cmpConfig.containerConfig.settings.normalizedFlatFaresForSchema = featuredDestinationToFlatFares(
          data.popularDestinations,
          data.topPopularDestination
        );
        resolve(cmpConfig);
      })
      .catch((err) => {
        logger.error(`PRELOAD_CUSTOM_PROPS: ${name}`, err);
        reject(err);
      });
  });
};

const preloadCustomProps = (cmpConfig) => {
  // HOC For all Common Preload Logic
  return withCommonPreloads(preloadCustomPropsExecute, cmpConfig);
};

export default preloadCustomProps;
